import { createRegisteredContext } from 'react-singleton-context'

import { AuthRuntime } from '../runtime/AuthRuntime'

export interface AuthContextValue {
    /** The runtime owns side effects, but consumers go through hooks, not this. */
    runtime: AuthRuntime
}

/**
 * Single, singleton React context shared by the host and every micro-frontend.
 * We use `react-singleton-context` (same pattern as `aos-singleton`'s
 * `AuthTokenContext`) so MFs loaded via Module Federation reuse the host's
 * context rather than creating their own.
 */
export const AuthContext = createRegisteredContext<AuthContextValue | null>('aos-auth', null)
